/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much should I tip?`)
};

const es_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto debo dar de propina?`)
};

const de_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel Trinkgeld sollte ich geben?`)
};

const nl_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel fooi moet ik geven?`)
};

const fr_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien dois-je donner de pourboire ?`)
};

const it_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto dovrei dare di mancia?`)
};

const pt_br2_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto devo dar de gorjeta?`)
};

const pt_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto devo dar de gorjeta?`)
};

const ja_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チップはいくら払うべきですか？`)
};

const zh_pct_tip_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应该给多少小费？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_faq1_q", locale)
	if (locale === "en") return en_pct_tip_faq1_q(inputs)
	if (locale === "es") return es_pct_tip_faq1_q(inputs)
	if (locale === "de") return de_pct_tip_faq1_q(inputs)
	if (locale === "nl") return nl_pct_tip_faq1_q(inputs)
	if (locale === "fr") return fr_pct_tip_faq1_q(inputs)
	if (locale === "it") return it_pct_tip_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_faq1_q(inputs)
	if (locale === "pt") return pt_pct_tip_faq1_q(inputs)
	if (locale === "ja") return ja_pct_tip_faq1_q(inputs)
	return zh_pct_tip_faq1_q(inputs)
};